import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { ExerciseDetailScreen } from './ExerciseDetailScreen';
import type { ExerciseDetailSearch } from './exercise-detail-search';

const route = getRouteApi('/exercises/$exerciseId');

export function ExerciseDetailRoute() {
  const { exerciseId } = route.useParams();
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: ExerciseDetailSearch) => {
      void navigate({ search: () => ({ tab: next.tab }) });
    },
    [navigate],
  );

  return <ExerciseDetailScreen exerciseId={exerciseId} search={search} onSearchChange={onSearchChange} />;
}
